import { Link } from "@tanstack/react-router";
import { Mail, Phone, Clock } from "lucide-react";
import logo from "@/assets/logo-investcapital-v4.png.asset.json";
import { trackConversion } from "@/lib/tracking-events";
import { openCookieSettings } from "@/lib/consent";
import { COMPANY } from "@/lib/company";


export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/60 bg-muted/40">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src={logo.url} alt="InvestCapital" width={70} height={40} className="h-10 w-auto" loading="lazy" />
            <div>
              <div className="font-display text-lg font-semibold">InvestCapital</div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground">
                Gestão &amp; Investimentos Imobiliários
              </div>
            </div>
          </div>
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">
            Compramos o seu imóvel a pronto pagamento! Sem burocracias, sem
            intermediários e sem comissões.
          </p>
        </div>

        <div>
          <h2 className="text-sm font-semibold text-foreground">Navegação</h2>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="text-muted-foreground hover:text-primary">Home</Link></li>
            <li><Link to="/vender-a-minha-casa" className="text-muted-foreground hover:text-primary">Vender a Minha Casa</Link></li>
            <li><Link to="/quem-somos" className="text-muted-foreground hover:text-primary">Quem Somos</Link></li>
            <li><Link to="/contactos" className="text-muted-foreground hover:text-primary">Contactos</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-sm font-semibold text-foreground">Contactos</h2>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <Phone className="mt-1 h-4 w-4 text-primary" />
              <div>
                <a href="tel:+351934371241" onClick={() => trackConversion("Contact", { method: "telefone" })} className="hover:text-primary">+351 934 371 241</a>
                <div className="text-xs text-muted-foreground">(Chamada para rede móvel nacional)</div>
              </div>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-primary" />
              <a href="mailto:proposta@investcapital.pt" onClick={() => trackConversion("Contact", { method: "email" })} className="hover:text-primary">proposta@investcapital.pt</a>

            </li>
            <li className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-primary" />
              Seg a Dom — 24h
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 px-4 py-5 text-center text-xs text-muted-foreground">
        <p className="mx-auto max-w-4xl">
          Responsável: {COMPANY.legalName} · {COMPANY.taxId ? `${COMPANY.taxLabel} ${COMPANY.taxId} · ` : ""}{COMPANY.addressLabel}: {COMPANY.address} ·{" "}
          Email: {COMPANY.email} · Tel./WhatsApp: {COMPANY.phone}
        </p>
        <nav aria-label="Informação legal" className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <Link to="/politica-de-privacidade" className="hover:text-primary">Política de Privacidade</Link>
          <Link to="/politica-de-cookies" className="hover:text-primary">Política de Cookies</Link>
          <Link to="/termos-e-condicoes" className="hover:text-primary">Termos e Condições</Link>
          <button type="button" onClick={openCookieSettings} className="hover:text-primary">Definições de cookies</button>
          <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
            Livro de Reclamações
          </a>
        </nav>
        <p className="mx-auto mt-3 max-w-4xl text-[11px] leading-relaxed">
          A InvestCapital é uma empresa de gestão e investimentos imobiliários e não atua como
          instituição financeira, entidade credora ou intermediária de crédito nos termos da
          legislação aplicável.
        </p>
        <p className="mt-3">
          © {new Date().getFullYear()} InvestCapital — investcapital.pt · Todos os direitos reservados
        </p>
      </div>

    </footer>
  );
}
